export default __webpack_public_path__ + "static/media/NoNotification.90e3c1f4.svg";